var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"col-sm-12 nopads"},_vm._l((_vm.results),function(team){return _c('team-item',{key:team.id,attrs:{"team":team},on:{"edit":_vm.emitEdit}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }